// Copied from mock-website/round-6/js/vaultchip.js (APP-R3 §7) for the entrance art; the original stays for the
// public home page, og-image.mjs and hero-fidelity. GENERATED by kit/restyle-vaultchip.mjs from app/src/site/hero/vaultChip.js
// (dark theme). Do not edit: change the source or the restyle script. The ZeroQube sample's header
// art: the live hero's scene and motion, redrawn in neutral grays and cobalt with thin outlines (LINE_K
// 0.55), restrained glows (GLOW_K 0.7) and a crisp under-slab beneath the deck.
// The home page hero: the v9 vault chip (app/art/vault-chip). This module is the reference
// prototype verbatim, prototype/kit.js followed by prototype/scene.js (with the background-tower
// patch applied), plus the site's caches (SPEC.md section 6). Changes from the prototype, all marked
// "site:" in comments:
// - kit(cv, fit, store) takes an optional cache store; with one, g.layer(key, paint) draws a
//   static layer once into an offscreen canvas cropped to its bounds and blits it 1:1 after that;
// - drawV9 uses g.layer, when present, for caches A1 (the city), B (deck and chip), C (glass and
//   incline) and D (the card at rest). Without a store every path is the prototype's own.
// e2e/hero-fidelity.spec.ts renders this module and the prototype side by side and compares pixels.

/* ---------- prototype/kit.js ---------- */
const C30 = Math.cos(Math.PI / 6), INK = '#111312', BG = '#1b1e1d';
function bezier(x1, y1, x2, y2) { const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by; const X = s => ((ax * s + bx) * s + cx) * s, Y = s => ((ay * s + by) * s + cy) * s; return x => { if (x <= 0) return 0; if (x >= 1) return 1; let lo = 0, hi = 1, s = x; for (let i = 0; i < 24; i++) { if (X(s) < x) lo = s; else hi = s; s = (lo + hi) / 2; } return Y(s); }; }
const easy = bezier(0.17, 0, 0.83, 1), clamp01 = t => Math.min(Math.max(t, 0), 1), seg = (t, a, b) => clamp01((t - a) / (b - a)), fall = p => p * p;
const flash = (t, at, decay) => (t < at - 0.08 || t > at + decay ? 0 : t < at ? (t - at + 0.08) / 0.08 : Math.pow(1 - (t - at) / decay, 2));
const mod = (a, n) => ((a % n) + n) % n;
const hash1 = a => { const s = Math.sin(a * 12.9898) * 43758.5453; return s - Math.floor(s); };
const rgb = c => [1, 3, 5].map(i => parseInt(c.slice(i, i + 2), 16));
const mix = (a, b, t) => { const A = rgb(a), B = rgb(b); return '#' + A.map((v, i) => Math.round(v + (B[i] - v) * t).toString(16).padStart(2, '0')).join(''); };
function hull(pts) { const p = pts.slice().sort((a, b) => a[0] - b[0] || a[1] - b[1]); const cr = (o, a, b) => (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); const lo = [], up = []; for (const q of p) { while (lo.length >= 2 && cr(lo[lo.length - 2], lo[lo.length - 1], q) <= 0) lo.pop(); lo.push(q); } for (let i = p.length - 1; i >= 0; i--) { const q = p[i]; while (up.length >= 2 && cr(up[up.length - 2], up[up.length - 1], q) <= 0) up.pop(); up.push(q); } up.pop(); lo.pop(); return lo.concat(up); }
const circle = (r, n = 32, x0 = 0, y0 = 0) => Array.from({ length: n }, (_, i) => { const a = i / n * Math.PI * 2; return [x0 + r * Math.cos(a), y0 + r * Math.sin(a)]; });
const bar = (r0, r1, a, w) => { const d = [Math.cos(a), Math.sin(a)], q = [-Math.sin(a), Math.cos(a)]; return [[r0 * d[0] + w * q[0], r0 * d[1] + w * q[1]], [r1 * d[0] + w * q[0], r1 * d[1] + w * q[1]], [r1 * d[0] - w * q[0], r1 * d[1] - w * q[1]], [r0 * d[0] - w * q[0], r0 * d[1] - w * q[1]]]; };

const M = {
  deck: ['#c9ccca', '#a9adab', '#8a8e8c'], tier: ['#8a8e8c', '#3a3d3c', '#2a2d2c'],
  near: ['#2e3130', '#272a29', '#161817'], far: ['#242726', '#1f2221', '#131514'],
  lav: ['#ecedec', '#d2d4d3', '#a9adab'], cap: ['#eeefee', '#d2d4d3', '#b4b7b5'], violet: ['#6f8fff', '#3763ff', '#2748cc'],
  mint: ['#7e9bff', '#5a80ff', '#3763ff'], gold: ['#e2e3e2', '#c2c5c3', '#9a9e9c'], chip: ['#3a3d3c', '#2a2d2c', '#111312'],
  pin: ['#d2d4d3', '#a9adab', '#8e9290'], belt: ['#3a3d3c', '#303332', '#272a29'], rail: '#272a29',
};

function kit(cv, fit, store) {
  const ctx = cv.getContext('2d'), W = cv.width, H = cv.height;
  const [a, b, c, d] = fit; const u = Math.min(W / (b - a), H / (d - c)); const lwk = 0.55 * Math.min(1, Math.max(0.55, u / 48));
  const ox = W / 2 - (a + b) / 2 * u, oy = H / 2 - (c + d) / 2 * u;
  const g = { ctx, W, H, u, lwk };
  g.P = (x, y, z) => [ox + (x - y) * C30 * u, oy + ((x + y) * 0.5 - z) * u];
  g.poly = (pts, fill, lw, ink) => { ctx.beginPath(); pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)); ctx.closePath(); if (fill) { ctx.fillStyle = fill; ctx.fill(); } if (lw) { ctx.strokeStyle = ink || INK; ctx.lineWidth = lw * lwk; ctx.lineJoin = 'round'; ctx.stroke(); } };
  g.box = (x0, y0, z0, x1, y1, z1, m, lw, ink) => { const P = g.P; g.poly([P(x1, y0, z0), P(x1, y1, z0), P(x1, y1, z1), P(x1, y0, z1)], m[2], lw, ink); g.poly([P(x0, y1, z0), P(x1, y1, z0), P(x1, y1, z1), P(x0, y1, z1)], m[1], lw, ink); g.poly([P(x0, y0, z1), P(x1, y0, z1), P(x1, y1, z1), P(x0, y1, z1)], m[0], lw, ink); };
  g.prismZ = (prof, cx, cy, z0, z1, top, side, lw) => { const tp = prof.map(([p, q]) => g.P(cx + p, cy + q, z1)); g.poly(hull(tp.concat(prof.map(([p, q]) => g.P(cx + p, cy + q, z0)))), side, lw); g.poly(tp, top, lw); };
  g.faceY = (y, xa, xb, za, zb, fill, lw) => g.poly([g.P(xa, y, za), g.P(xb, y, za), g.P(xb, y, zb), g.P(xa, y, zb)], fill, lw);
  g.faceX = (x, ya, yb, za, zb, fill, lw) => g.poly([g.P(x, ya, za), g.P(x, yb, za), g.P(x, yb, zb), g.P(x, ya, zb)], fill, lw);
  g.path = (pts, color, w, cap = 'round') => { ctx.beginPath(); pts.forEach((p, i) => { const [x, y] = g.P(...p); i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); }); ctx.strokeStyle = color; ctx.lineWidth = Math.max(w * u, 0.75); ctx.lineJoin = 'round'; ctx.lineCap = cap; ctx.stroke(); };
  g.glow = (x, y, z, r, al, col = '95,131,255') => { if (al <= 0.01) return; const [cx, cy] = g.P(x, y, z), R = r * u; const gr = ctx.createRadialGradient(cx, cy, 0, cx, cy, R); gr.addColorStop(0, `rgba(${col},${Math.min(al * 0.7, 1)})`); gr.addColorStop(1, `rgba(${col},0)`); ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.fillStyle = gr; ctx.fillRect(cx - R, cy - R, 2 * R, 2 * R); ctx.restore(); };
  g.alpha = (al, fn) => { const p = ctx.globalAlpha; ctx.globalAlpha = p * al; fn(); ctx.globalAlpha = p; };
  g.clipPoly = (pts, fn) => { ctx.save(); ctx.beginPath(); pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)); ctx.closePath(); ctx.clip(); fn(); ctx.restore(); };
  // site: a static layer, painted once into an offscreen canvas at this canvas's own pixel transform,
  // cropped to the layer's bounds on whole device pixels, then blitted 1:1 at the current globalAlpha.
  // The store belongs to one kit, so a resize, a new pixel ratio or a new fit starts an empty one.
  if (store) g.layer = (key, paint) => {
    let L = store.get(key);
    if (!L) {
      const m = ctx.getTransform(), cw = ctx.canvas.width, ch = ctx.canvas.height;
      const [bx0, by0, bx1, by1] = layerBounds(W, H, fit, paint);
      const x0 = Math.max(0, Math.floor(bx0 * m.a + m.e)), y0 = Math.max(0, Math.floor(by0 * m.d + m.f));
      const x1 = Math.min(cw, Math.ceil(bx1 * m.a + m.e)), y1 = Math.min(ch, Math.ceil(by1 * m.d + m.f));
      const c = document.createElement('canvas');
      c.width = Math.max(1, x1 - x0); c.height = Math.max(1, y1 - y0);
      const lc = c.getContext('2d');
      lc.setTransform(m.a, m.b, m.c, m.d, m.e - x0, m.f - y0);
      paint(kit({ width: W, height: H, getContext: () => lc }, fit));
      L = { c, x: x0, y: y0 };
      store.set(key, L);
    }
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(L.c, L.x, L.y); ctx.restore();
  };
  return g;
}
// site: the bounds of a layer in CSS pixels, from a dry run of its paint over a context that only
// records coordinates, padded by half the widest stroke and 2 px for anti-aliasing.
function layerBounds(W, H, fit, paint) {
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, lw = 0;
  const pt = (x, y) => { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; };
  const grad = { addColorStop() {} };
  const rec = {
    lineWidth: 1, globalAlpha: 1, moveTo: pt, lineTo: pt, fillRect: (x, y, w, h) => { pt(x, y); pt(x + w, y + h); },
    stroke() { lw = Math.max(lw, this.lineWidth); },
    beginPath() {}, closePath() {}, fill() {}, clip() {}, save() {}, restore() {},
    createRadialGradient: () => grad, createLinearGradient: () => grad,
  };
  paint(kit({ width: W, height: H, getContext: () => rec }, fit));
  const pad = lw / 2 + 2;
  return x0 > x1 ? [0, 0, 0, 0] : [x0 - pad, y0 - pad, x1 + pad, y1 + pad];
}
const dist3 = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1], b[2] - a[2]);
const pathLen = pts => pts.slice(1).reduce((s, p, i) => s + dist3(pts[i], p), 0);
function at(pts, d) { for (let i = 1; i < pts.length; i++) { const a = pts[i - 1], b = pts[i], l = dist3(a, b); if (d <= l || i === pts.length - 1) { const f = l ? clamp01(d / l) : 0; return [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2] + (b[2] - a[2]) * f]; } d -= l; } return pts[pts.length - 1]; }
// rounded corners for flat polylines
function rounded(pts, r = 0.35, n = 5) { const out = [pts[0]]; for (let i = 1; i < pts.length - 1; i++) { const A = pts[i - 1], B = pts[i], C = pts[i + 1]; const la = dist3(A, B), lc = dist3(B, C), rr = Math.min(r, la / 2, lc / 2); const p0 = B.map((v, k) => v + (A[k] - v) * rr / la), p1 = B.map((v, k) => v + (C[k] - v) * rr / lc); for (let j = 0; j <= n; j++) { const s = j / n; out.push(p0.map((v, k) => (1 - s) * (1 - s) * v + 2 * (1 - s) * s * B[k] + s * s * p1[k])); } } out.push(pts[pts.length - 1]); return out; }

/* ---------- prototype/scene.js ---------- */
// v9: reference prototype of the final build spec. Every frame is a pure function of loop time t in [0, 20),
// or, on a first visit, of boot time p (t = (T0 + p) mod 20, and chains that started before the page are skipped).
// Uses kit.js (kit, circle, bar, hull, mix, easy, seg, fall, flash, mod, hash1, rounded, at, pathLen, dist3).
const LOOP = 20, T0 = 17.3;
const UNDER = ['#111312', '#111312', '#111312'];  // zq: the deck's under-slab
const BG8 = '#1b1e1d';
const M8 = {
  deck: ['#c9ccca', '#a9adab', '#8a8e8c'], tier: ['#8a8e8c', '#3a3d3c', '#2a2d2c'],
  slate: ['#9ea2a0', '#7d817f', '#626664'], chip: ['#3a3d3c', '#2a2d2c', '#111312'],
  lav: ['#ecedec', '#d2d4d3', '#a9adab'], violet: ['#6f8fff', '#3763ff', '#2748cc'],
  mint: ['#7e9bff', '#5a80ff', '#3763ff'], gold: ['#e2e3e2', '#c2c5c3', '#9a9e9c'],
  near: ['#2a2d2c', '#242726', '#151716'], far: ['#1f2221', '#1d201f', '#121413'],
  cap: ['#d2d4d3', '#a9adab', '#8e9290'], card: ['#5b5f5d', '#8a8e8c', '#3d403f'],
  incl: ['#2a2d2c', '#232625', '#1a1c1b'], post: ['#2e3130', '#272a29', '#1e2120'],
};
const LAVRGB = '214,216,215', MINTRGB = '95,131,255', GOLDRGB = '214,222,255';
const SPENDS = [0, 2, 4, 6, 8, 10, 12, 14];
const DEPOS = [1.65, 3.65, 5.65, 7.65, 9.65, 11.65, 13.65, 16.6];
const H0 = 5;
const FADE = [[0, 1], [0.10, 1], [0.40, 0.88], [0.55, 0.68], [0.70, 0.45], [0.85, 0.20], [0.98, 0], [1, 0]];

/* ---------- static geometry ---------- */
const REMOVED8 = new Set(['0,0', '1,0', '0,1', '5,0', '6,0', '6,1', '6,6', '5,6', '6,5', '0,4']);
const TABS = [[1, 7], [2, 7]];
/* ---------- city: two attached clusters, a front pair, one connection network (towers patch) ---------- */
// Towers are boxes from z -30 to zTop. Format: id, x0, y0, x1, y1, zTop, material, window colour, grid.
// Array order is NOT the draw order; ORDER8 is (painter's order by separating axis, checked by check_city.cjs).
const TOWERS8 = [
  // west cluster: landmark LA, annex LB on LA's +y wall, far slim LC low at the frame edge (its outline runs behind LB)
  ['LC', -7.4, 7.6, -6.6, 8.4, -3.0, 'far'],
  ['LA', -4.5, 7.0, -3.0, 8.5, 0.0, 'near', '#d2d4d3', 'fine'],
  ['LB', -4.5, 8.5, -3.0, 10.3, -1.8, 'near'],
  // front row (Jito's front blocks): LD under the deck's front-left edge, RF under its front-right edge; both lit
  ['LD', 3.0, 7.4, 4.9, 9.3, -0.8, 'near', '#6f8fff', 'coarse'],
  // east cluster: landmark RA, shoulder RB on RA's +x wall (the lift runs down RB's +x face), far slim RC at RB's
  // right edge (rail H1 over RB's roof into RA, sky bridge B2 into RD), dark block RD right of the lift
  ['RA', 4.6, -2.7, 6.1, -1.2, -0.2, 'near', '#6f8fff', 'fine'],
  ['RB', 6.1, -2.7, 8.25, -1.2, -1.4, 'near'],
  ['RC', 8.25, -3.5, 9.05, -2.7, -0.5, 'far'],
  ['RD', 11.0, -3.0, 12.9, -1.1, -1.0, 'near'],
  ['RF', 7.2, 4.71, 9.1, 6.61, -0.52, 'near', '#d2d4d3', 'coarse'],
];
// Rails: flat bands at one z each, centrelines on the floor axes. Every end plugs into a tower face,
// goes under the deck / incline, enters a tower's hidden back face, or leaves the frame.
const RAILS8 = [
  [[-3.4, 8.5, -1.4], [-3.4, 11.4, -1.4], [3.9, 11.4, -1.4], [3.9, 9.3, -1.4]],  // R1: LA +y face, over LB, under the incline, into LD +y face
  [[3.0, -0.75, -1.5], [3.0, -1.95, -1.5], [4.6, -1.95, -1.5]],                 // R3: from under the deck's back-right edge into RA's hidden -x face
  [[12.0, -1.1, -2.2], [12.0, 0.4, -2.2], [16.5, 0.4, -2.2]],                   // R5: RD +y face, off the frame bottom right
  [[8.65, -2.7, -1.0], [8.65, -2.4, -1.0], [6.1, -2.4, -1.0]],                  // H1: RC +y face, over RB's roof, into RA +x face
];
// per rail: id, corner radii (one per interior corner), socket plates where an end plugs into a visible face
// (sock: [end, face], end 0 = first point, 1 = last; face 'y' = the +y face, 'x' = the +x face)
const RAILMETA8 = [
  { id: 'R1', r: [0.9, 0.6], sock: [[0, 'y'], [1, 'y']] },
  { id: 'R3', r: [0.5, 0.5] },
  { id: 'R5', r: [0.9, 0.9], sock: [[0, 'y']] },
  { id: 'H1', r: [0.15], sock: [[0, 'y'], [1, 'x']] },
];
// links: sky bridges (plain NEAR boxes)
const LINKS8 = {
  B2: { box: [9.05, -2.95, -1.5, 11.0, -2.75, -1.25] },  // RC +x face to RD's hidden -x face
};
// draw order (back to front). Rails and links by id, towers by id, 'LIFT' is the lift posts.
const ORDER8 = ['LC', 'LA', 'LB', 'LD', 'R1', 'R3', 'RA', 'RB', 'RC', 'H1', 'B2', 'LIFT', 'RD', 'R5', 'RF'];
const DEP_BUS = [[1.0, 7.5, 0.005], [2.5, 7.5, 0.005], [2.5, 5.4, 0.005]];
const OUT_BUS = [[5.4, 2.5, 0.005], [7.57, 2.5, 0.005]];
const PINS = Array.from({ length: 8 }, (_, k) => 2.1 + 0.4 * k);
const LANES = [
  { x: -0.1, col: '#ecedec', cad: 0.4 },
  { x: 0.225, col: '#d2d4d3', cad: 0.5 },
  { x: 0.55, col: '#6f8fff', cad: 0.8 },
];
const HOP = { cx: 0.225, cy: 7.8, zb: 0.35, zt: 0.95, hb: 0.4, ht: 0.75 };
const inclPath = (x) => [[x, 15.2, -3.9], [x, 8.85, 1.2], [x, 8.4, 1.2]];
const FALL_T = 0.34;
const CARD = { x0: 1.17, x1: 1.41, y0: 2.15, y1: 5.05, z0: 0.32, z1: 2.0 };
const LEAFY = Array.from({ length: 8 }, (_, k) => 4.8 - 0.35 * k);
const L1Y = [4.625, 3.925, 3.225, 2.525], L2Y = [4.275, 2.875], ROOTY = 3.575;
const LEAFZ = 1.74, L1Z = 1.34, L2Z = 1.0, ROOTZ = 0.62;
// light paths over the chip's surfaces
const SIG_PATH = [[1.45, 3.575, 0.33], [1.58, 3.575, 0.33], [1.95, 3.575, 0.6], [2.35, 3.575, 0.6], [2.35, 3.575, 0.741], [2.88, 3.5, 0.741], [2.88, 3.5, 0.81], [3.36, 3.5, 0.86], [3.5, 3.5, 0.9]];
const DRAIN_PATH = [[3.938, 3.062, 0.76], [4.24, 2.76, 0.745], [4.65, 2.5, 0.745], [4.65, 2.5, 0.6], [5.05, 2.5, 0.6], [5.05, 2.5, 0.2], [5.23, 2.5, 0.205]];
const ENTRY_UP = [[2.5, 5.4, 0.0], [2.5, 5.4, 0.2], [2.5, 5.23, 0.205], [2.5, 5.05, 0.205], [2.5, 5.05, 0.6], [2.5, 4.65, 0.6]];
const EXIT_DOWN = [[5.23, 2.5, 0.205], [5.4, 2.5, 0.2], [5.4, 2.5, 0.0]];
const LAMP_PATH = [[2.27, 1.28], [2.27, 0.84], [3.575, 0.84], [3.575, 0.76]]; // (y, z) on the card face
const cellAng = (i) => (22.5 + 45 * i) * Math.PI / 180;
function depLid(i) {
  const th = cellAng(i), a0 = 120 * Math.PI / 180;
  let d = th - a0; d = mod(d + Math.PI, 2 * Math.PI) - Math.PI;
  const pts = [[2.5, 4.65, 0.6], [2.5, 4.65, 0.742]];
  const n = Math.max(1, Math.ceil(Math.abs(d) / (7.5 * Math.PI / 180)));
  for (let k = 0; k <= n; k++) { const a = a0 + d * k / n; pts.push([3.5 + 1.06 * Math.cos(a), 3.5 + 1.06 * Math.sin(a), 0.742]); }
  pts.push([3.5 + 0.93 * Math.cos(th), 3.5 + 0.93 * Math.sin(th), 0.742]);
  return pts;
}
const ENTRY_LEN = pathLen(ENTRY_UP);
const DEP_IN = Array.from({ length: 8 }, (_, i) => ENTRY_UP.concat(depLid(i).slice(1)));

/* ---------- clock helpers ---------- */
function since(t, E, lead, dur) {
  for (const m of [0, -1, 1]) { const s = t - E - m * LOOP; if (s >= -lead && s <= dur) return s; }
  return null;
}
const easeOut = (p) => 1 - (1 - p) * (1 - p);
const smooth = (p) => p * p * (3 - 2 * p);
const beltD = (t) => 0.64 * (Math.floor(t / 0.4) + easy(seg(t - Math.floor(t / 0.4) * 0.4, 0, 0.25)));

/* ---------- small drawing helpers ---------- */
function sqX(g, x, y, z, s, col, lw) { g.poly([g.P(x, y - s, z - s), g.P(x, y + s, z - s), g.P(x, y + s, z + s), g.P(x, y - s, z + s)], col, lw); }
function flat(g, x0, y0, x1, y1, z, col, lw) { g.poly([g.P(x0, y0, z), g.P(x1, y0, z), g.P(x1, y1, z), g.P(x0, y1, z)], col, lw); }
function arcPoly(g, cx, cy, z, r0, r1, a0, a1, n = 6) {
  const pts = [];
  for (let i = 0; i <= n; i++) { const a = a0 + (a1 - a0) * i / n; pts.push(g.P(cx + r1 * Math.cos(a), cy + r1 * Math.sin(a), z)); }
  for (let i = n; i >= 0; i--) { const a = a0 + (a1 - a0) * i / n; pts.push(g.P(cx + r0 * Math.cos(a), cy + r0 * Math.sin(a), z)); }
  return pts;
}
function ringStroke(g, cx, cy, z, r, col, wU, a) {
  if (a <= 0.01) return;
  const c = g.ctx; c.save(); c.globalAlpha *= a; c.beginPath();
  circle(r, 40).forEach(([p, q], i) => { const [x, y] = g.P(cx + p, cy + q, z); i ? c.lineTo(x, y) : c.moveTo(x, y); });
  c.closePath(); c.strokeStyle = col; c.lineWidth = Math.max(0.75, wU * g.u); c.stroke(); c.restore();
}
function dot(g, p, size, col, a = 1, minPx = 1.5) {
  const [x, y] = g.P(...p), R = Math.max(minPx, size * g.u);
  const c = g.ctx, pa = c.globalAlpha; c.globalAlpha = pa * a; c.fillStyle = col; c.fillRect(x - R / 2, y - R / 2, R, R); c.globalAlpha = pa;
}
function bus(g, pts, col, w = 0.06) {
  for (const o of [-0.09, 0, 0.09]) {
    const q = pts.map((p, i) => {
      const a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
      const dx = b[0] - a[0], dy = b[1] - a[1], Lg = Math.hypot(dx, dy) || 1;
      return [p[0] - (dy / Lg) * o, p[1] + (dx / Lg) * o, p[2]];
    });
    g.path(rounded(q, 0.25), col, w, 'butt');
  }
}
function packet(g, pts, d, col, rgb, clipPts) {
  const path = rounded(pts, 0.25), Lp = pathLen(path);
  const a = at(path, Math.max(0, d - 0.25)), b = at(path, Math.min(Lp, d + 0.25)), c = at(path, d);
  const draw = () => { g.path([a, b], col, 0.26, 'round'); g.path([a, b], '#ffffff', 0.08, 'round'); g.glow(c[0], c[1], c[2], 0.45, 0.55, rgb); };
  clipPts ? g.clipPoly(clipPts, draw) : draw();
}
function subPath(pts, d0, d1) {
  const out = [at(pts, d0)]; let acc = 0;
  for (let i = 1; i < pts.length; i++) { acc += dist3(pts[i - 1], pts[i]); if (acc > d0 && acc < d1) out.push(pts[i]); }
  out.push(at(pts, d1));
  return out;
}
// a light run: head at distance `head`, fixed tail length; colour bands by distance [{until, col, ink}]
function lightRun(g, pts, head, tail, bands, rgb, headGlow = true) {
  const d0 = Math.max(0, head - tail), d1 = head;
  if (d1 - d0 < 1e-4) return;
  let start = d0;
  for (const b of bands) {
    const end = Math.min(d1, b.until);
    if (end > start) { const sp = subPath(pts, start, end); if (b.ink) g.path(sp, INK, 0.1); g.path(sp, b.col, 0.05); start = end; }
  }
  if (headGlow) { const h = at(pts, d1); g.glow(h[0], h[1], h[2], 0.25, 0.6, rgb); }
}
// half-plane clip "keep x > v" built at the object's height z
function clipHalf(g, v, z) { const B = 40; return [g.P(v, -B, z), g.P(B, -B, z), g.P(B, B, z), g.P(v, B, z)]; }
// union of the press doorway and the half-plane beyond the door face (both sub-paths, one clip)
function clipDoorway(g, fn) {
  const c = g.ctx, A = [g.P(8.75, 2.15, -0.5), g.P(8.75, 2.85, -0.5), g.P(8.75, 2.85, -0.14), g.P(8.75, 2.15, -0.14)], Bp = clipHalf(g, 8.75, -0.5);
  c.save(); c.beginPath();
  for (const poly of [A, Bp]) { poly.forEach(([x, y], i) => (i ? c.lineTo(x, y) : c.moveTo(x, y))); c.closePath(); }
  c.clip('nonzero'); fn(); c.restore();
}

/* ---------- state at time t ---------- */
function state(t, opts) {
  const p = opts.p, first = p !== undefined, boot = first && p < 2.8;
  const st = { t, first, boot, p };
  // a chain instance is live if its elapsed time is in range and (first visit) it started after the page did
  st.live = (s) => s !== null && (!first || s <= p);
  // holdings FIFO
  st.H = H0 + DEPOS.filter((X) => X + 0.97 <= t).length;
  st.T = SPENDS.filter((F) => F + 1.15 <= t).length;
  // card swap
  if (t >= 16.5 && t < 17.3) st.sink = 2.12 * fall(seg(t, 16.5, 17.3));
  else if (t >= 17.3 && t < 17.7) st.sink = 3;
  else if (t >= 17.7 && t < 18.6) st.sink = 2.12 * (1 - easeOut(seg(t, 17.7, 18.6)));
  else st.sink = 0;
  st.swap = t >= 16.3 && t < 18.8;
  st.clamp = 0.15 * (easy(seg(t, 16.3, 16.5)) - easy(seg(t, 18.6, 18.8)));
  st.lamp = t >= 12.55 && t < 14.62 ? '#d2d4d3' : t >= 14.62 && t < 18.8 ? '#2a2d2c' : '#7e9bff';
  // door
  let wheelU = 0, ret = 0, glint = 0;
  let key = first ? (p < 1.96 ? 0 : p < 2.35 ? Math.max(0, seg(p, 1.96, 2.0) - 0.65 * seg(p, 2.0, 2.35)) : 0.35) : 0.35;
  for (const F of SPENDS) {
    const s = since(t, F, 0, 3);
    if (!st.live(s)) continue;
    const env = easy(seg(s, 1.0, 1.15)) - fall(seg(s, 1.46, 1.58));
    wheelU += env; ret = Math.max(ret, env);
    if (s >= 0.98 && s < 1.96) key = Math.max(key, s < 1.58 ? seg(s, 0.98, 1.06) : 1 - 0.65 * seg(s, 1.58, 1.96));
    glint = Math.max(glint, flash(s, 1.58, 0.2));
  }
  // re-key ripple after spend 7 (loop) or the Initialize ripple (boot)
  const rip = (x, a0) => [0, 1, 2, 3].map((b) => { const a = a0 + 0.06 * b; return { env: easy(seg(x, a, a + 0.1)) - fall(seg(x, a + 0.1, a + 0.18)), gl: flash(x, a + 0.18, 0.2) }; });
  const R = boot ? rip(p, 2.0) : rip(t, 15.66);
  st.boltK = R.map((r) => Math.max(ret, 0.6 * r.env));
  st.glintK = R.map((r) => Math.max(glint, r.gl));
  const jog = Math.max(...R.map((r) => r.env));
  st.wheel = -Math.PI / 2 * wheelU - (20 * Math.PI / 180) * jog;
  st.ring = boot ? flash(p, 2.45, 0.25) : flash(t, 16.05, 0.25);
  st.key = key;
  return st;
}

/* ---------- cacheable layers ---------- */
// City colours. Towers keep v9's NEAR / FAR materials (M8.near, M8.far).
const CITY8 = {
  rail: { edge: '#2d302f', body: '#242726', line: '#363938' },   // track band: lighter edges, dark bed, centre line
  sock: '#151716',                                               // socket plate where a rail end meets a visible face
  car: '#474b49',                                                // data cars: mix(slate, BG, 0.35), no brighter than the windows
  winMix: { near: [0.42, 0.58], far: [0.6, 0.72] },              // window colour = mix(col, BG, k) on +y / +x faces
};
const towerById = (id) => TOWERS8.find((T) => T[0] === id);
// Regular window grid (Jito's facade rule): 6 columns on both faces, no gaps, pitch from the face length.
function faceGrid(L) { const m = 0.12 * L, p = (L - 2 * m) / 5.4, rp = 1.09 * p; return { m, p, w: 0.4 * p, rp, h: 0.43 * rp, band: 2.45 * rp }; }
function winRows(T) {
  const [, x0, y0, x1, y1, z, , , grid] = T, F = faceGrid(Math.min(x1 - x0, y1 - y0));
  if (grid === 'fine') return 12;
  return Math.min(40, Math.max(0, Math.floor((z - F.band - ((x0 + y0) / 2 - 11.6)) / F.rp)));  // blocks run out of every crop
}
function winSlot(T, face, r, c) { // [a0, a1, zBottom, zTop] of window (row r, column c) on the +y ('y') or +x ('x') face
  const [, x0, y0, x1, y1, z] = T, F = faceGrid(face === 'y' ? x1 - x0 : y1 - y0);
  const zt = z - F.band - r * F.rp, a = (face === 'y' ? x0 : y0) + F.m + c * F.p;
  return [a, a + F.w, zt - F.h, zt];
}
function quadsFill(g, quads, fill) { // one fill call for many quads (cache-friendly, cheap when drawn live)
  const c = g.ctx; c.beginPath();
  for (const q of quads) { q.forEach(([x, y], i) => (i ? c.lineTo(x, y) : c.moveTo(x, y))); c.closePath(); }
  c.fillStyle = fill; c.fill();
}
function towerWindows(g, T) {
  const [, x0, y0, x1, y1, , mat, col] = T, P = g.P, rows = winRows(T), k = CITY8.winMix[mat], qy = [], qx = [];
  for (let r = 0; r < rows; r++) for (let c = 0; c < 6; c++) {
    const [a0, a1, zb, zt] = winSlot(T, 'y', r, c); qy.push([P(a0, y1, zb), P(a1, y1, zb), P(a1, y1, zt), P(a0, y1, zt)]);
    const [b0, b1, wb, wt] = winSlot(T, 'x', r, c); qx.push([P(x1, b0, wb), P(x1, b1, wb), P(x1, b1, wt), P(x1, b0, wt)]);
  }
  quadsFill(g, qy, mix(col, BG8, k[0])); quadsFill(g, qx, mix(col, BG8, k[1]));
}
// rounded polyline with one radius per interior corner
function roundedR(pts, radii, n = 8) {
  const out = [pts[0]];
  for (let i = 1; i < pts.length - 1; i++) {
    const A = pts[i - 1], B = pts[i], C = pts[i + 1], la = dist3(A, B), lc = dist3(B, C), rr = Math.min(radii[i - 1] || 0, la / 2, lc / 2);
    if (rr <= 0) { out.push(B); continue; }
    const p0 = B.map((v, k) => v + (A[k] - v) * rr / la), p1 = B.map((v, k) => v + (C[k] - v) * rr / lc);
    for (let j = 0; j <= n; j++) { const s = j / n; out.push(p0.map((v, k) => (1 - s) * (1 - s) * v + 2 * (1 - s) * s * B[k] + s * s * p1[k])); }
  }
  out.push(pts[pts.length - 1]); return out;
}
const RAILPTS8 = RAILS8.map((P, i) => roundedR(P, RAILMETA8[i].r));  // rounded centrelines, built once
function cityRail(g, i) {
  const pts = RAILPTS8[i], R = CITY8.rail, P = RAILS8[i];
  for (const [end, face] of RAILMETA8[i].sock || []) {  // face-aligned socket plate (0.34 x 0.22) under the rail end
    const [x, y, z] = end ? P[P.length - 1] : P[0], hs = 0.17, hz = 0.11;
    const q = face === 'y'
      ? [[x - hs, y, z - hz], [x + hs, y, z - hz], [x + hs, y, z + hz], [x - hs, y, z + hz]]
      : [[x, y - hs, z - hz], [x, y + hs, z - hz], [x, y + hs, z + hz], [x, y - hs, z + hz]];
    g.poly(q.map((v) => g.P(...v)), CITY8.sock, 0.6, BG8);
  }
  // one solid ribbon (body lighter than the old bed) with a centre line, as Jito's rails read
  g.path(pts, R.edge, 0.26 * C30, 'butt'); g.path(pts, R.body, 0.20 * C30, 'butt'); g.path(pts, R.line, 0.03, 'butt');
}
function cityBridge(g, L) { const [x0, y0, z0, x1, y1, z1] = L.box; g.box(x0, y0, z0, x1, y1, z1, M8.near, 0.6, BG8); }
function liftPosts(g) {
  g.box(9.15, -1.12, -30, 9.23, -1.04, -0.42, M8.post, 0.6, BG8);
  g.box(9.57, -1.12, -30, 9.65, -1.04, -0.42, M8.post, 0.6, BG8);
  g.box(9.15, -1.12, -0.5, 9.65, -1.04, -0.42, M8.post, 0.6, BG8);
}
function cityItem(g, id) {
  if (id === 'LIFT') return liftPosts(g);
  const T = towerById(id);
  if (T) { g.box(T[1], T[2], -30, T[3], T[4], T[5], M8[T[6]], 0.8, BG8); if (T[7]) towerWindows(g, T); return; }
  const ri = RAILMETA8.findIndex((m) => m.id === id);
  if (ri >= 0) return cityRail(g, ri);
  cityBridge(g, LINKS8[id]);
}
// Cache A1: every tower with its own windows straight after it, rails, links and the lift posts, in ORDER8.
// Windows are on at every width, phone included (2 fills per lit tower), so A1 does not depend on the phone flag;
// cache it keyed on W, H, dpr and fit. A1 is faded as ONE layer, never per element (see drawV9).
function layerA1(g) { for (const id of ORDER8) cityItem(g, id); }
function layerA2() {}  // windows moved into A1 (a back tower's windows must not paint over a front tower)
// Toggles: <= 8 slots per frame, only on landmark +y-face slots that nothing covers, A1 or foreground (rows, columns).
const TOGGLE8 = [['LA', 3, 0, 6], ['RA', 5, 0, 6]];
// Data cars: slate, small, on the visible span [d0, d1] of a rail (distance along the rounded centreline).
// period divides the 20 s loop, so every frame is a pure, seamless function of t.
const CARS8 = [
  { rail: 0, n: 2, period: 10, d0: 0.15, d1: 11.55, dir: -1 },  // R1: from LD's face, under the incline, up into LA
];  // no car on R3: it would be the only motion in the top-centre band, under the headline
function cityTraffic(g, t) {
  for (const C of CARS8) {
    const pts = RAILPTS8[C.rail], span = C.d1 - C.d0;
    for (let k = 0; k < C.n; k++) {
      const s = mod(t / C.period + k / C.n, 1), d = C.dir > 0 ? C.d0 + s * span : C.d1 - s * span;
      const a = Math.min(1, (d - C.d0) / 0.35, (C.d1 - d) / 0.35);
      if (a <= 0) continue;
      const p = at(pts, d), q = at(pts, d + 0.02), L = Math.hypot(q[0] - p[0], q[1] - p[1]) || 1;
      const ux = (q[0] - p[0]) / L, uy = (q[1] - p[1]) / L, hl = 0.16, hw = 0.065, z = p[2] + 0.012;
      const c = (sa, sw) => g.P(p[0] + ux * hl * sa - uy * hw * sw, p[1] + uy * hl * sa + ux * hw * sw, z);
      g.alpha(a, () => g.poly([c(-1, -1), c(1, -1), c(1, 1), c(-1, 1)], CITY8.car));
    }
  }
}
function windowToggles(g, t, opts) {
  if (!opts.phone && !opts.still) {
    const beat = Math.floor(t);
    for (let b = beat - 3; b <= beat; b++) for (let k = 0; k < 2; k++) {
      const h = hash1(mod(b, LOOP) * 7.13 + k * 3.7), [id, nr, c0, c1] = TOGGLE8[Math.floor(h * TOGGLE8.length)];
      const T = towerById(id), r = Math.floor(hash1(h * 91) * nr), c = c0 + Math.floor(hash1(h * 53) * (c1 - c0));
      const [a0, a1, zb, zt] = winSlot(T, 'y', r, c);
      const e = 0.01;  // cover the cached window's anti-aliased edge
      g.faceY(T[4], a0 - e, a1 + e, zb - e, zt + e, M8[T[6]][1]);  // a lit slot goes dark for its beat
    }
  }
  cityTraffic(g, t);
}
function deckTiles() {
  const tiles = [];
  for (let i = 0; i < 7; i++) for (let j = 0; j < 7; j++) if (!REMOVED8.has(i + ',' + j)) tiles.push([i, j]);
  return tiles.sort((a, b) => a[0] + a[1] - b[0] - b[1]);
}
function intakeBody(g) {
  g.box(-0.95, 6.75, -1.6, 1.0, 8.9, -1.4, M8.tier, 1.0);
  g.box(-0.55, 7.05, -1.4, 1.0, 8.55, 0.35, M8.slate, 1.4);
  g.faceX(1.0, 7.3, 7.7, 0.0, 0.26, '#111312', 0.9);
  g.faceX(1.0, 7.95, 8.25, -0.75, 0.15, '#111312', 0.9);
  const { cx, cy, zb, zt, hb, ht } = HOP, P = g.P;
  g.poly([P(cx - hb, cy - hb, zb), P(cx + hb, cy - hb, zb), P(cx + hb, cy + hb, zb), P(cx - hb, cy + hb, zb)], '#2a2d2c', 0.8);
  g.poly([P(cx - hb, cy - hb, zb), P(cx - hb, cy + hb, zb), P(cx - ht, cy + ht, zt), P(cx - ht, cy - ht, zt)], '#7d817f', 1.0);
  g.poly([P(cx - hb, cy - hb, zb), P(cx + hb, cy - hb, zb), P(cx + ht, cy - ht, zt), P(cx - ht, cy - ht, zt)], '#8e9290', 1.0);
}
function chipPackage(g, B) {
  const dz = B ? B.drop : 0;
  g.box(1.95, 1.95, 0.2 + dz, 5.05, 5.05, 0.6 + dz, M8.chip, 1.5);
  g.box(2.35, 2.35, 0.6 + dz, 4.65, 4.65, 0.74 + dz, M8.lav, 1.5);
  for (let i = 0; i < 8; i++) { const a = cellAng(i); g.poly(arcPoly(g, 3.5, 3.5, 0.741 + dz, 0.86, 1.0, a - 0.32, a + 0.32), '#c2c5c3', 0.5); }
  for (let b = 0; b < 4; b++) g.poly(bar(0.70, 0.84, Math.PI / 4 + b * Math.PI / 2, 0.06).map(([p, q]) => g.P(3.5 + p, 3.5 + q, 0.741 + dz)), '#111312');
  g.poly(circle(0.7, 40).map(([a, b]) => g.P(3.5 + a, 3.5 + b, 0.741 + dz)), '#2a2d2c', 0.8);
}
function pads(g, B) {
  PINS.forEach((v, i) => {
    flat(g, v - 0.07, 5.12, v + 0.07, 5.34, 0.201, mix('#a9adab', '#ecedec', B ? B.pin(i) : 0), 0.5);
    flat(g, 5.12, v - 0.07, 5.34, v + 0.07, 0.201, mix('#a9adab', '#ecedec', B ? B.pin(8 + i) : 0), 0.5);
  });
}
// cache B, in the fixed order of spec section 6
function layerB(g, B) {
  const tA = (i, j) => (B ? B.tile(i, j) : 1), mid = B ? B.mid : 1, chip = B ? B.chip : 1;
  for (const [i, j] of deckTiles()) g.alpha(tA(i, j), () => g.box(i + 0.06, j + 0.06, -0.58, i + 1.06, j + 1.06, -0.22, UNDER, 0));  // zq: under-slab
  for (const [i, j] of deckTiles()) g.alpha(tA(i, j), () => g.box(i, j, -0.22, i + 1, j + 1, 0, M8.deck, 0.7));
  g.alpha(mid, () => intakeBody(g));
  for (const [i, j] of TABS) g.alpha(tA(i, j), () => g.box(i, j, -0.22, i + 1, j + 1, 0, M8.deck, 0.7));
  g.alpha(mid, () => {
    g.box(7.0, 2.15, -0.1, 7.35, 2.85, 0.0, M8.chip, 0.9);
    bus(g, DEP_BUS, '#3a3d3c'); bus(g, OUT_BUS, '#3a3d3c');
    g.box(1.0, 2.0, 0, 1.58, 5.2, 0.32, M8.slate, 1.2);
    flat(g, 1.13, 2.1, 1.45, 5.1, 0.321, '#111312');
  });
  g.alpha(tA(3, 3), () => {
    g.box(1.6, 1.6, 0, 5.4, 5.4, 0.2, M8.slate, 1.4);
    g.faceY(5.4, 2.43, 2.57, 0, 0.2, '#a9adab'); g.faceX(5.4, 2.43, 2.57, 0, 0.2, '#a9adab');
  });
  g.alpha(mid, () => g.poly([g.P(1.58, 3.35, 0.32), g.P(1.95, 3.35, 0.6), g.P(1.95, 3.8, 0.6), g.P(1.58, 3.8, 0.32)], '#3a3d3c', 0.7));
  g.alpha(tA(3, 3), () => pads(g, B));
  g.alpha(chip, () => chipPackage(g, B));
}
// cache C
function layerC(g) {
  const { cx, cy, zb, zt, hb, ht } = HOP, P = g.P;
  g.alpha(0.22, () => {
    g.poly([P(cx + hb, cy - hb, zb), P(cx + hb, cy + hb, zb), P(cx + ht, cy + ht, zt), P(cx + ht, cy - ht, zt)], '#d2d4d3');
    g.poly([P(cx - hb, cy + hb, zb), P(cx + hb, cy + hb, zb), P(cx + ht, cy + ht, zt), P(cx - ht, cy + ht, zt)], '#ecedec');
  });
  g.poly([P(cx + hb, cy - hb, zb), P(cx + hb, cy + hb, zb), P(cx + ht, cy + ht, zt), P(cx + ht, cy - ht, zt)], null, 1.2);
  g.poly([P(cx - hb, cy + hb, zb), P(cx + hb, cy + hb, zb), P(cx + ht, cy + ht, zt), P(cx - ht, cy + ht, zt)], null, 1.2);
  const rim = [P(cx - ht, cy - ht, zt), P(cx + ht, cy - ht, zt), P(cx + ht, cy + ht, zt), P(cx - ht, cy + ht, zt)], c = g.ctx;
  c.save(); c.beginPath(); rim.forEach(([x, y], i) => (i ? c.lineTo(x, y) : c.moveTo(x, y))); c.closePath();
  c.strokeStyle = INK; c.lineWidth = 0.11 * g.u; c.lineJoin = 'round'; c.stroke();
  c.strokeStyle = '#d2d4d3'; c.lineWidth = 0.06 * g.u; c.stroke(); c.restore();
  const x0 = -0.3, x1 = 0.75, A = [15.2, -3.9], Bq = [8.85, 1.2], C = [8.4, 1.2], th = 0.06;
  g.poly([P(x1, A[0], A[1] - th), P(x1, Bq[0], Bq[1] - th), P(x1, C[0], C[1] - th), P(x1, C[0], C[1]), P(x1, Bq[0], Bq[1]), P(x1, A[0], A[1])], M8.incl[2], 0.8, BG8);
  g.poly([P(x0, A[0], A[1]), P(x1, A[0], A[1]), P(x1, Bq[0], Bq[1]), P(x1, C[0], C[1]), P(x0, C[0], C[1]), P(x0, Bq[0], Bq[1])], M8.incl[0], 0.8, BG8);
  for (const l of LANES) g.path(inclPath(l.x).map(([x, y, z]) => [x, y, z + 0.005]), '#343736', 0.05, 'butt');
}
// cache D: the card's static parts at sink depth d (live and clipped during the swap)
const FACE_X = CARD.x1 + 0.001;
function faceClip(g, fn) { g.clipPoly([g.P(FACE_X, -40, 0.32), g.P(FACE_X, 40, 0.32), g.P(FACE_X, 40, 9), g.P(FACE_X, -40, 9)], fn); }
function cardBack(g, st) { const c = st.clamp; g.box(1.02, 2.0 - c, 0.32, 1.56, 2.18 - c, 0.58, M8.cap, 1.0); }
function cardFront(g, st) { const c = st.clamp; g.box(1.02, 5.02 + c, 0.32, 1.56, 5.2 + c, 0.58, M8.cap, 1.0); }
function cardBody(g, d) {
  const top = CARD.z1 - d;
  if (top > CARD.z0) g.box(CARD.x0, CARD.y0, CARD.z0, CARD.x1, CARD.y1, top, M8.card, 1.3);
  if (top + 0.1 > CARD.z0) g.box(CARD.x0 - 0.04, CARD.y0, Math.max(CARD.z0, top), CARD.x1 + 0.04, CARD.y1, top + 0.1, M8.cap, 1.3);
}
function faceStatic(g, d) {
  const X = FACE_X, zc = (z) => z - d, tr = '#c9ccca', P = g.P;
  const s2 = (a, b) => g.path([[X, a[0], zc(a[1])], [X, b[0], zc(b[1])]], tr, 0.03, 'butt');
  LEAFY.forEach((y, k) => { const m = k >> 1; s2([y, LEAFZ - 0.11], [y, 1.52]); s2([y, 1.52], [L1Y[m], 1.52]); s2([L1Y[m], 1.52], [L1Y[m], L1Z + 0.08]); });
  L1Y.forEach((y, m) => { const n = m >> 1; s2([y, L1Z - 0.08], [y, 1.17]); s2([y, 1.17], [L2Y[n], 1.17]); s2([L2Y[n], 1.17], [L2Y[n], L2Z + 0.09]); });
  L2Y.forEach((y) => { s2([y, L2Z - 0.09], [y, 0.84]); s2([y, 0.84], [ROOTY, 0.84]); });
  s2([ROOTY, 0.84], [ROOTY, ROOTZ + 0.14]);
  s2([2.27, 1.28], [2.27, 0.84]); s2([2.27, 0.84], [2.875, 0.84]); // lamp feed into the root bus
  for (let i = 0; i < 12; i++) { const y = 2.3 + 0.22 * i; g.poly([P(X, y, zc(0.34)), P(X, y + 0.1, zc(0.34)), P(X, y + 0.1, zc(0.44)), P(X, y, zc(0.44))], M8.gold[1]); }
  L1Y.forEach((y) => sqX(g, X, y, zc(L1Z), 0.08, '#8e9290', 0.6));
  L2Y.forEach((y) => sqX(g, X, y, zc(L2Z), 0.09, '#8e9290', 0.6));
}

/* ---------- spend and deposit chains ---------- */
function spendChains(st, dur) { return SPENDS.map((F, k) => ({ F, k, s: since(st.t, F, 0, dur) })).filter((c) => st.live(c.s)); }
function depChains(st, dur) { return DEPOS.map((X, j) => ({ X, j, r: since(st.t, X, 0, dur) })).filter((c) => st.live(c.r)); }

function leafState(st, k) {
  const t = st.t, idle = '#5a80ff', dead = '#2a2d2c';
  if (t >= 17.5) { const p = seg(t, 18.65 + 0.045 * k, 18.77 + 0.045 * k); return { col: p > 0 ? mix('#3a3d3c', idle, p) : '#3a3d3c', glow: 0.4 * flash(t, 18.77 + 0.045 * k, 0.15) }; }
  const s = t - SPENDS[k];
  if (s < 0) return { col: idle, glow: 0 };
  if (st.first && s > st.p) return { col: dead, glow: 0 };
  if (s < 0.25) return { col: mix(idle, '#7e9bff', easy(s / 0.25)), glow: 0.4 * s / 0.25 };
  if (s < 0.35) return { col: '#e4eaff', glow: 0.55 };
  if (s < 0.55) return { col: mix('#7e9bff', dead, seg(s, 0.35, 0.55)), glow: 0.4 * (1 - seg(s, 0.35, 0.55)) };
  return { col: dead, glow: 0 };
}
function authHops(k) {
  const m = k >> 1, n = k >> 2, y = LEAFY[k];
  return [
    [[y, LEAFZ - 0.11], [y, 1.52], [L1Y[m], 1.52], [L1Y[m], L1Z + 0.08]],
    [[L1Y[m], L1Z - 0.08], [L1Y[m], 1.17], [L2Y[n], 1.17], [L2Y[n], L2Z + 0.09]],
    [[L2Y[n], L2Z - 0.09], [L2Y[n], 0.84], [ROOTY, 0.84], [ROOTY, ROOTZ + 0.14]],
  ];
}
const onFace = (yz, d) => yz.map(([y, z]) => [FACE_X, y, z - d]);
function cardDynamic(g, st) {
  const d = st.sink;
  // auth path (lit, growing hop by hop), and the still's afterglow
  for (const { k, s } of spendChains(st, 1.0)) {
    if (s < 0.25) continue;
    const al = 1 - seg(s, 0.7, 1.0);
    authHops(k).forEach((h, i) => {
      const p = seg(s, 0.25 + 0.123 * i, 0.37 + 0.123 * i); if (p <= 0) return;
      const pts = onFace(h, d), L = pathLen(pts);
      g.alpha(al, () => g.path(subPath(pts, 0, p * L), '#7e9bff', 0.05));
    });
  }
  if (st.still) g.alpha(0.35, () => { authHops(st.stillLeaf).forEach((h) => g.path(onFace(h, d), '#7e9bff', 0.05)); g.path(onFace([[ROOTY, ROOTZ - 0.14], [ROOTY, 0.33]], d), '#7e9bff', 0.05); });
  // root: spend flash (mint), new-card match glow (lavender)
  let f = 0, fl = 0;
  for (const { s } of spendChains(st, 2)) f = Math.max(f, flash(s, 0.62, 0.18));
  if (st.bootInit !== null) f = Math.max(f, flash(st.bootInit, 0.62, 0.18));
  if (!st.boot) fl = flash(st.t, 18.9, 0.2);
  if (st.still) f = Math.max(f, 0.6);
  sqX(g, FACE_X, ROOTY, ROOTZ - d, 0.14, fl > f ? mix('#a9adab', '#ecedec', fl) : mix('#a9adab', '#e4eaff', f), 0.8);
  // leaves
  LEAFY.forEach((y, k) => { const lf = leafState(st, k); sqX(g, FACE_X, y, LEAFZ - d, 0.11, lf.col, 0.7); if (lf.glow > 0.01) g.glow(FACE_X, y, LEAFZ - d, 0.32, lf.glow, MINTRGB); });
  sqX(g, FACE_X, 2.27, 1.34 - d, 0.06, st.lamp, 0.5);
  if (f > 0.01) g.glow(FACE_X, ROOTY, ROOTZ - d, 0.42, (st.still ? 0.3 / 0.6 : 0.5) * f, MINTRGB);
  if (fl > 0.01) g.glow(FACE_X, ROOTY, ROOTZ - d, 0.42, 0.5 * fl, LAVRGB);
  // spend 7 carries the next tree: a lavender pip from the lamp to the root
  for (const { k, s } of spendChains(st, 1.0)) if (k === 7 && s >= 0.25 && s <= 0.62) {
    const pts = onFace(LAMP_PATH, d), h = at(pts, pathLen(pts) * seg(s, 0.25, 0.62));
    dot(g, h, 0.07, '#ecedec'); g.glow(h[0], h[1], h[2], 0.25, 0.5, LAVRGB);
  }
}
function cardGroup(g, st) {
  const d = st.sink;
  if (st.cached && !st.swap && d === 0 && st.clamp === 0) {
    // site: cache D, the card at rest (back clamp, body, cap, face traces, fingers, L1 and L2 nodes);
    // the front clamp stays live below and keeps the prototype's place after the dynamic face,
    // whose canvas state (the last line cap set) its strokes inherit
    g.layer('D', (h) => { cardBack(h, st); cardBody(h, 0); faceStatic(h, 0); });
    cardDynamic(g, st);
  } else {
    cardBack(g, st);
    if (d < 2.1 - 0.32) {
      cardBody(g, d);
      if (st.swap) faceClip(g, () => { faceStatic(g, d); cardDynamic(g, st); });
      else { faceStatic(g, d); cardDynamic(g, st); }
    }
  }
  cardFront(g, st);
  const sg = 0.35 * seg(st.t, 17.35, 17.7) * (1 - seg(st.t, 17.9, 18.2));
  if (sg > 0.01) g.glow(1.29, 3.6, 0.33, 1.1, sg, LAVRGB);
}
// the signature leaves the card: drop on the face, slot flash (comet itself is drawn with the door)
function sigCard(g, st) {
  const run = (s, k) => {
    if (s >= 0.62 && s < 0.8) {
      const z = ROOTZ - 0.14 - (ROOTZ - 0.14 - CARD.z0) * seg(s, 0.62, 0.8);
      dot(g, [FACE_X + 0.01, ROOTY, z], 0.09, '#e4eaff'); g.glow(FACE_X, ROOTY, z, 0.3, 0.6, MINTRGB);
      if (k === 7) dot(g, [FACE_X + 0.01, ROOTY + 0.13, z], 0.07, '#ecedec');
    }
    g.glow(1.29, ROOTY, 0.33, 0.5, 0.6 * flash(s, 0.8, 0.15), MINTRGB);
  };
  for (const { s, k } of spendChains(st, 1.0)) run(s, k);
  if (st.bootInit !== null) run(st.bootInit, -1);
}
function sigComet(g, st) {
  const L = pathLen(SIG_PATH);
  const run = (s) => { if (s < 0.8 || s > 1.0) return; lightRun(g, SIG_PATH, L * seg(s, 0.8, 0.98), 0.5 * (1 - seg(s, 0.98, 1.0)), [{ until: 99, col: '#7e9bff', ink: true }], MINTRGB, s < 0.98); };
  for (const { s } of spendChains(st, 1.0)) run(s);
  if (st.bootInit !== null) run(st.bootInit);
  if (st.still) g.alpha(0.35, () => g.path(SIG_PATH, '#7e9bff', 0.05));
}

/* ---------- lid, door ---------- */
function lidOverlays(g, st) {
  const t = st.t;
  // holdings, FIFO; the head pops when a deposit arrives, the tail dims when a spend takes it
  for (let idx = st.T - 1; idx <= st.H; idx++) {
    const i = mod(idx, 8), a = cellAng(i);
    let lit = idx >= st.T && idx < st.H ? 1 : 0;
    const j = idx - H0, popT = j >= 0 && j < 8 ? DEPOS[j] + 0.97 : null;
    if (popT !== null && t >= popT && t < popT + 0.12) lit = (t - popT) / 0.12;
    const drT = idx >= 0 && idx < 8 ? SPENDS[idx] + 1.15 : null;
    if (drT !== null && t >= drT && t < drT + 0.12) lit = 1 - (t - drT) / 0.12;
    if (st.reveal) lit *= st.reveal(idx - st.T);
    if (lit <= 0) continue;
    g.poly(arcPoly(g, 3.5, 3.5, 0.742, 0.86, 1.0, a - 0.32, a + 0.32), mix('#c2c5c3', '#3763ff', lit), 0.6);
  }
  // deposits: lead climb, pin ripple, climb into the lid, round the ring to the head cell, pop
  for (const { r, j } of depChains(st, 1.3)) {
    const i = (H0 + j) % 8, path = DEP_IN[i], L = pathLen(path);
    PINS.forEach((v, pi) => { const f = flash(r, 0.633 + 0.04 * Math.abs(pi - 1), 0.2); if (f > 0.01) flat(g, v - 0.07, 5.12, v + 0.07, 5.34, 0.202, mix('#a9adab', '#ecedec', f)); });
    if (r >= 0.6 && r <= 1.01) {
      const head = r < 0.72 ? ENTRY_LEN * seg(r, 0.6, 0.72) : ENTRY_LEN + (L - ENTRY_LEN) * seg(r, 0.72, 0.97);
      lightRun(g, path, head, 0.5 * (1 - seg(r, 0.97, 1.01)), [{ until: ENTRY_LEN, col: '#ecedec' }, { until: 99, col: '#6f8fff', ink: true }], LAVRGB, r < 0.97);
    }
    const a = cellAng(i), pr = r - 0.97;
    if (pr >= 0 && pr < 0.3) g.glow(3.5 + 0.93 * Math.cos(a), 3.5 + 0.93 * Math.sin(a), 0.75, 0.3, 0.5 * (1 - pr / 0.3), LAVRGB);
  }
  // spends: mint ripple on the exit pins; lead down the socket's +x face
  for (const { s } of spendChains(st, 1.6)) {
    PINS.forEach((v, pi) => { const f = flash(s, 1.45 + 0.04 * Math.abs(pi - 1), 0.2); if (f > 0.01) flat(g, 5.12, v - 0.07, 5.34, v + 0.07, 0.202, mix('#a9adab', '#7e9bff', f)); });
    if (s >= 1.45 && s <= 1.53) lightRun(g, EXIT_DOWN, pathLen(EXIT_DOWN) * seg(s, 1.45, 1.5), 0.3 * (1 - seg(s, 1.5, 1.53)), [{ until: 99, col: '#7e9bff' }], MINTRGB, s < 1.5);
  }
  if (st.still) g.alpha(0.35, () => g.path(DRAIN_PATH, '#7e9bff', 0.05));
  door(g, st);
  // drain: the tail cell's light runs in to the door, the door's ring flashes, the light leaves through bolt 3's channel
  for (const { s, k } of spendChains(st, 1.6)) {
    const a = cellAng(k % 8);
    if (s >= 1.15 && s <= 1.27) { const A = [3.5 + 0.86 * Math.cos(a), 3.5 + 0.86 * Math.sin(a), 0.745], B = [3.5 + 0.7 * Math.cos(a), 3.5 + 0.7 * Math.sin(a), 0.745]; lightRun(g, [A, B], 0.16 * seg(s, 1.15, 1.25), 0.16 * (1 - seg(s, 1.25, 1.27)), [{ until: 99, col: '#7e9bff', ink: true }], MINTRGB, s < 1.25); }
    if (s >= 1.25 && s <= 1.5) { const L = pathLen(DRAIN_PATH); lightRun(g, DRAIN_PATH, L * seg(s, 1.25, 1.45), 0.5 * (1 - seg(s, 1.45, 1.5)), [{ until: 99, col: '#7e9bff', ink: true }], MINTRGB, s < 1.45); }
  }
}
function door(g, st) {
  const cx = 3.5, cy = 3.5, zt = 0.81, P = g.P;
  ringStroke(g, cx, cy, 0.745, 0.72, '#7e9bff', 0.07, st.ring);
  const stub = (b) => {
    const a = Math.PI / 4 + b * Math.PI / 2, r0 = 0.56 - 0.22 * st.boltK[b];
    if (r0 + 0.26 <= 0.62) return;
    g.prismZ(bar(Math.max(r0, 0.62), r0 + 0.26, a, 0.05), cx, cy, 0.755, 0.795, M8.gold[0], M8.gold[2], 0.8);
  };
  stub(1); stub(2); stub(3);
  g.prismZ(circle(0.62, 40), cx, cy, 0.74, zt, '#dadcdb', '#a9adab', 1.2);
  ringStroke(g, cx, cy, zt, 0.47, '#6f8fff', 1.2 / g.u * g.lwk, 1);
  let rf = 0; for (const { s } of spendChains(st, 1.6)) rf = Math.max(rf, flash(s, 1.22, 0.15));
  ringStroke(g, cx, cy, zt, 0.47, '#7e9bff', 0.06, rf);
  stub(0);
  for (let k = 0; k < 4; k++) g.prismZ(bar(0.1, 0.4, st.wheel + k * Math.PI / 2, 0.035), cx, cy, zt, zt + 0.05, '#3763ff', '#5b5f5d', 0.8);
  for (let k = 0; k < 4; k++) { const a = st.wheel + k * Math.PI / 2; g.prismZ(circle(0.055, 12, 0.42 * Math.cos(a), 0.42 * Math.sin(a)), cx, cy, zt, zt + 0.08, '#6f8fff', '#2748cc', 0.8); }
  g.prismZ(circle(0.14, 20), cx, cy, zt, zt + 0.09, '#6f8fff', '#2748cc', 1.0);
  for (const { s, k } of spendChains(st, 1.6)) if (k === 7) ringStroke(g, cx, cy, 0.9, 0.2, '#6f8fff', 0.04, flash(s, 0.98, 0.25));
  sigComet(g, st);
  const k = st.key, kc = k <= 0.001 ? '#111312' : k <= 0.35 ? mix('#111312', '#3763ff', k / 0.35) : mix('#3763ff', '#7e9bff', (k - 0.35) / 0.65);
  g.poly(circle(0.055, 14).map(([a, b]) => P(cx + a, cy + b, 0.901)), kc, 0.5);
  if (k > 0.5) g.glow(cx, cy, 0.91, 0.45, 0.6 * (k - 0.35), MINTRGB);
  if (!st.still) for (let b = 0; b < 4; b++) {
    const a = Math.PI / 4 + b * Math.PI / 2, r = 0.56 - 0.22 * st.boltK[b] + 0.26;
    if (st.glintK[b] > 0.01) g.glow(cx + r * Math.cos(a), cy + r * Math.sin(a), 0.795, 0.22, 0.7 * st.glintK[b], GOLDRGB);
  }
}

/* ---------- deposit packet, right side ---------- */
function deposits(g, st) {
  const Lp = pathLen(rounded(DEP_BUS, 0.25));
  for (const { r } of depChains(st, 0.7)) {
    if (r < 0.05 || r > 0.6) continue;
    packet(g, DEP_BUS, Math.max(0, Lp * seg(r, 0.05, 0.6) - 0.25), '#ecedec', LAVRGB, clipHalf(g, 1.0, 0));
  }
}
function token(g, x, y, z) { g.prismZ(circle(0.24, 6), x, y, z, z + 0.12, M8.mint[0], M8.mint[2], 1.1); }
function outflow(g, st) {
  let liftZ = -0.5, liftTok = null;
  for (const { s } of spendChains(st, 7.2)) {
    if (s >= 5.05 && s < 6.1) { liftZ = -0.5 - 5 * fall(seg(s, 5.15, 6.0)); liftTok = s < 6.0 ? liftZ : null; }
    else if (s >= 6.1 && s < 6.85) liftZ = -5.5 + 5 * easy(seg(s, 6.1, 6.85));
  }
  g.box(9.1, -1.0, liftZ - 0.08, 9.7, -0.4, liftZ, M8.chip, 0.9);
  if (liftTok !== null) g.alpha(st.mov, () => token(g, 9.4, -0.7, liftTok));
  // tier
  const prof = [[0, 0], [2.0, 0], ...circle(0.5, 12, 2.0, 0.5).filter(([a, b]) => b <= 0.5 && a >= 2.0), [2.5, 0.5], [2.5, 3.45], ...circle(0.5, 12, 2.0, 3.45).filter(([a, b]) => b >= 3.45 && a >= 2.0), [2.0, 3.95], [0, 3.95]];
  g.prismZ(hull(prof), 7.35, -0.35, -0.7, -0.5, M8.tier[0], M8.tier[1], 1.0);
  flat(g, 9.1, -0.3, 9.7, 3.4, -0.499, '#2a2d2c', 0.6);
  const off = mod(beltD(st.t), 0.32);
  for (let y = 3.35 - off; y > -0.25; y -= 0.32) g.path([[9.13, y, -0.498], [9.67, y, -0.498]], '#4b4f4d', 0.025, 'butt');
  press(g, st);
  // tokens: through the doorway, a dwell, a step onto the band, then the belt (ascending y)
  const toks = [];
  for (const { s } of spendChains(st, 5.1)) {
    if (s < 2.6) continue;
    if (s < 3.2) { const x = s < 2.95 ? 8.45 + 0.41 * easeOut(seg(s, 2.6, 2.95)) : 8.86 + 0.54 * easy(seg(s, 3.05, 3.2)); toks.push({ y: 2.5, x, clip: true }); }
    else toks.push({ y: 2.5 - Math.min(3.2, beltD(s - 3.2)), x: 9.4 });
  }
  toks.sort((a, b) => a.y - b.y);
  for (const tk of toks) g.alpha(st.mov, () => (tk.clip ? clipDoorway(g, () => token(g, tk.x, tk.y, -0.5)) : token(g, tk.x, tk.y, -0.5)));
}
function press(g, st) {
  let charge = 0, rise = 0, fl = 0, sock = 0;
  for (const { s } of spendChains(st, 3.2)) {
    sock = Math.max(sock, flash(s, 1.95, 0.3));
    if (s >= 1.95 && s < 2.57) { charge = Math.max(charge, fall(seg(s, 1.95, 2.45))); rise = Math.max(rise, s < 2.45 ? easeOut(seg(s, 1.95, 2.45)) : 1 - fall(seg(s, 2.45, 2.57))); }
    fl = Math.max(fl, flash(s, 2.57, 0.15));
    if (s >= 2.57 && s < 2.75) charge = Math.max(charge, 1 - seg(s, 2.57, 2.75));
  }
  g.box(7.35, 1.9, -0.5, 8.75, 3.1, 0.0, M8.violet, 1.4);
  g.faceX(8.75, 2.15, 2.85, -0.5, -0.14, '#111312', 1.0);
  g.faceY(3.1, 7.5, 8.6, -0.36, -0.24, '#8a8e8c', 0.6);
  if (charge > 0) g.faceY(3.101, 7.5, 7.5 + 1.1 * charge, -0.36, -0.24, '#7e9bff');
  flat(g, 7.42, 2.3, 7.72, 2.7, 0.002, mix('#111312', '#7e9bff', sock), 0.7);
  outPackets(g, st);
  g.box(8.0, 2.2, 0.0, 8.6, 2.8, 0.7, M8.slate, 1.2);
  const zc = 0.7 + 0.3 * rise;
  g.box(7.93, 2.13, zc, 8.67, 2.87, zc + 0.18, M8.lav, 1.2);
  g.glow(8.05, 2.5, 0.05, 0.6, 0.5 * fl, MINTRGB);
  g.glow(7.57, 2.5, 0.02, 0.35, 0.6 * sock, MINTRGB);
}
function outPackets(g, st) {
  const Lp = pathLen(rounded(OUT_BUS, 0.25));
  for (const { s } of spendChains(st, 2.2)) {
    if (s < 1.5 || s > 1.95) continue;
    packet(g, OUT_BUS, Math.min(Lp - 0.25, Lp * seg(s, 1.5, 1.95)), '#7e9bff', MINTRGB, clipHalf(g, 5.4, 0));
  }
}

/* ---------- intake ---------- */
function heapAt(t, still) {
  let prev = -Infinity, next = Infinity;
  for (const m of [-1, 0, 1]) for (const X of DEPOS) { const e = X + m * LOOP; if (e <= t && e > prev) prev = e; if (e > t && e < next) next = e; }
  const fill = smooth(seg(t, prev + 0.15, next - 0.1));
  const h = t < prev + 0.12 ? 0.04 + 0.22 * (1 - fall(seg(t, prev, prev + 0.12))) : 0.04 + 0.22 * fill;
  const gauge = t - prev < 0.15 ? 1 - (t - prev) / 0.15 : fill;
  return { prev, next, h, gauge };
}
function intakeDynamic(g, st) {
  const t = st.t, P = g.P, { cx, cy, zb } = HOP, H = heapAt(t);
  if (H.gauge > 0.005) g.faceX(1.001, 8.02, 8.23, -0.73, -0.73 + 0.86 * H.gauge, mix('#a9adab', '#ecedec', H.gauge));
  const pf = flash(t - H.prev, 0.08, 0.3);
  if (pf > 0.01) g.faceX(1.001, 7.3, 7.7, 0.0, 0.26, mix('#111312', '#d2d4d3', pf), 0.9);
  const b = 0.33, z = zb + 0.02, ap = [cx, cy, z + H.h];
  g.poly([P(cx - b, cy - b, z), P(cx + b, cy - b, z), P(...ap)], '#a9adab', 0.6);
  g.poly([P(cx - b, cy - b, z), P(cx - b, cy + b, z), P(...ap)], '#a9adab', 0.6);
  g.poly([P(cx + b, cy - b, z), P(cx + b, cy + b, z), P(...ap)], '#d2d4d3', 0.6);
  g.poly([P(cx - b, cy + b, z), P(cx + b, cy + b, z), P(...ap)], '#ecedec', 0.6);
  // particles leave the lip with the belt's speed and land on the heap, behind the glass
  LANES.forEach((l) => {
    if (st.phone && l.cad === 0.8) return;
    const trip = pathLen(inclPath(l.x)) / 2.5, xe = l.x + 0.6 * (cx - l.x);
    const zh = 0.37 + H.h * (1 - Math.max(Math.abs(xe - cx), 0.25) / 0.33);
    for (let n = Math.floor((t - trip - FALL_T) / l.cad); n <= Math.floor((t - trip) / l.cad); n++) {
      const tau = t - n * l.cad - trip;
      if (tau < 0 || tau > FALL_T) continue;
      const q = tau / FALL_T;
      dot(g, [l.x + (xe - l.x) * q, 8.4 - 0.85 * q, 1.2 - (1.2 - zh) * q * q], 0.075, l.col, st.mov, st.phone ? 2 : 1.5);
    }
  });
  // the merge flash, inside the glass
  g.glow(cx, cy, 0.5, 0.8, 0.45 * flash(t - H.prev, 0, 0.2) * st.mov, LAVRGB);
}
function inclineParticles(g, st) {
  const t = st.t;
  LANES.forEach((l) => {
    if (st.phone && l.cad === 0.8) return;
    const pts = inclPath(l.x), trip = pathLen(pts) / 2.5;
    for (let n = Math.floor((t - trip) / l.cad); n <= Math.floor(t / l.cad); n++) {
      const tau = t - n * l.cad;
      if (tau < 0 || tau > trip) continue;
      const d = tau * 2.5, lift = (v, i) => (i === 2 ? v + 0.04 : v);
      dot(g, at(pts, d).map(lift), 0.075, l.col, st.mov, st.phone ? 2 : 1.5);
      if (!st.phone && d > 0.13) dot(g, at(pts, d - 0.13).map(lift), 0.05, l.col, 0.8 * st.mov);
    }
  });
}

/* ---------- the whole frame ---------- */
function bootAlphas(p) {
  if (p === undefined || p >= 2.8) return null;
  return {
    far: easy(seg(p, 0, 0.6)), win: easy(seg(p, 0.5, 1.1)), mid: easy(seg(p, 0.3, 0.8)),
    tile: (i, j) => easy(seg(p, 0.2 + 0.035 * (i + j), 0.35 + 0.035 * (i + j))),
    chip: seg(p, 0.5, 0.6), drop: 0.3 * (1 - fall(seg(p, 0.5, 0.85))),
    pin: (i) => flash(p, 0.85 + 0.025 * i, 0.2),
    mov: easy(seg(p, 0.9, 1.7)),
    reveal: (n) => seg(p, 1.0 + 0.08 * n, 1.1 + 0.08 * n),
  };
}
const STILL_T = 7.85;
function drawV9(g, t, opts = {}) {
  const B = bootAlphas(opts.p);
  if (opts.p !== undefined) t = mod(T0 + opts.p, LOOP);
  if (opts.still) t = opts.stillT || STILL_T;
  const st = state(t, opts);
  st.still = !!opts.still; st.phone = !!opts.phone; st.mov = B ? B.mov : 1;
  st.bootInit = st.boot ? opts.p - 0.98 : null;
  if (st.still) { st.stillLeaf = SPENDS.filter((F) => F + 1.15 <= t).length - 1; st.glintK = [0, 0, 0, 0]; }
  if (B) st.reveal = B.reveal;
  const mid = B ? B.mid : 1, chip = B ? B.chip : 1;
  const { ctx } = g;
  // site: B, C and D are cached once the power-up has left them at rest. By p 1.5 every boot alpha
  // they use is final (tiles 0.70, mid 0.8, chip 0.6, drop 0.85, the last pin flash 1.425).
  const cached = !!g.layer && (opts.p === undefined || opts.p >= 1.5);
  st.cached = cached;
  ctx.clearRect(0, 0, g.W, g.H);
  if (g.layer) g.alpha(B ? B.far : 1, () => g.layer('A1', layerA1));  // site: cache A1, blitted at layer alpha (towers/ANALYSIS.md section 5)
  else {
    layerA1(g);  // full alpha, then one layer-alpha pass: overlapping towers must not x-ray during the power-up
    if (B && B.far < 1) {  // A1 is the only thing on the canvas yet, so this scales A1's alpha alone (the site blits cached A1 at globalAlpha = B.far)
      ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.globalCompositeOperation = 'destination-in';
      ctx.fillStyle = `rgba(0,0,0,${B.far})`; ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height); ctx.restore();
    }
  }
  g.alpha(B ? B.far * B.win : 1, () => { layerA2(g, opts); windowToggles(g, t, opts); });
  if (cached) g.layer('B', (h) => layerB(h, null));  // site: cache B (with the power-up over, layerB(g, B) draws exactly layerB(g, null))
  else layerB(g, B);
  g.alpha(mid, () => cardGroup(g, st));
  g.alpha(st.mov, () => sigCard(g, st));
  g.alpha(st.mov, () => deposits(g, st));
  g.alpha(chip, () => lidOverlays(g, st));
  g.alpha(mid, () => outflow(g, st));
  g.alpha(mid, () => intakeDynamic(g, st));
  g.alpha(mid, () => (cached ? g.layer('C', layerC) : layerC(g)));  // site: cache C
  inclineParticles(g, st);
  if (!opts.nofade) {
    ctx.save(); ctx.globalCompositeOperation = 'destination-in';
    const gr = ctx.createLinearGradient(0, 0, 0, g.H);
    for (const [s, m] of FADE) gr.addColorStop(s, `rgba(0,0,0,${m})`);
    ctx.fillStyle = gr; ctx.fillRect(0, 0, g.W, g.H); ctx.restore();
  }
  if (opts.flatten !== false) { ctx.save(); ctx.globalCompositeOperation = 'destination-over'; ctx.fillStyle = BG8; ctx.fillRect(0, 0, g.W, g.H); ctx.restore(); }
}

export { kit, drawV9, LOOP, STILL_T };
